import { render, staticRenderFns } from "./LogsPage.vue?vue&type=template&id=2368f080&lang=pug&"
import script from "./LogsPage.vue?vue&type=script&lang=js&"
export * from "./LogsPage.vue?vue&type=script&lang=js&"
import style0 from "./LogsPage.vue?vue&type=style&index=0&id=2368f080&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports